import ScrollToTop from "./ScrollToTop";
import "./header";
import "./service-section";
import "./homepage-animation";

// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
    import.meta.hot.accept(() => {});
}

const backToTopButton = document.getElementById("BackToTop");
if (backToTopButton) {
    new ScrollToTop(backToTopButton);
}
